window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

(function(){
  'use strict';

  /*Coomon Codes*/
  theme.Sections = function Sections() {
		this.constructors = {};
		this.instances = [];

		document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
		document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
		document.addEventListener('shopify:section:select', this._onSelect.bind(this));
		document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
		document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
		document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
	};

	theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
		_createInstance: function(container, constructor, scope) {
		  var id = container.getAttribute('data-section-id');
		  var type = container.getAttribute('data-section-type');

		  constructor = constructor || this.constructors[type];

		  if (typeof constructor === 'undefined') {
		    return;
		  }

		  // If custom scope passed, check to see if instance
		  // is already initialized so we don't double up
		  if (scope) {
		    var instanceExists = this._findInstance(id);
		    if (instanceExists) {
		      this._removeInstance(id);
		    }
		  }

		  // If a section fails to init, handle the error without letting all subsequest section registers to fail
		  try {
		    var instance = Object.assign(new constructor(container), {
		      id: id,
		      type: type,
		      container: container
		    });
		    this.instances.push(instance);
		  } catch (e) {
		    console.error(e);
		  }
		},

		_findInstance: function(id) {
		  for (var i = 0; i < this.instances.length; i++) {
		    if (this.instances[i].id === id) {
		      return this.instances[i];
		    }
		  }
		},

		_removeInstance: function(id) {
		  var i = this.instances.length;
		  var instance;

		  while(i--) {
		    if (this.instances[i].id === id) {
		      instance = this.instances[i];
		      this.instances.splice(i, 1);
		      break;
		    }
		  }

		  return instance;
		},

		_onSectionLoad: function(evt, subSection, subSectionId) {
		  if (window.AOS) { AOS.refreshHard() }
		  if (theme && theme.initGlobals) {
		    theme.initGlobals();
		  }

		  var container = subSection ? subSection : evt.target;
		  var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');

		  if (!section) {
		    return;
		  }

		  this._createInstance(section);

		  var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

		  // Check if we have subsections to load
		  var haveSubSections = container.querySelectorAll('[data-subsection]');
		  if (haveSubSections.length) {
		    this.loadSubSections(container);
		  }

		  // Run JS only in case of the section being selected in the editor
		  // before merchant clicks "Add"
		  if (instance && typeof instance.onLoad === 'function') {
		    instance.onLoad(evt);
		  }

		  // Force editor to trigger scroll event when loading a section
		  setTimeout(function() {
		    window.dispatchEvent(new Event('scroll'));
		  }, 200);
		},

		_onSectionUnload: function(evt) {
		  this.instances = this.instances.filter(function(instance) {
		    var isEventInstance = instance.id === evt.detail.sectionId;

		    if (isEventInstance) {
		      if (typeof instance.onUnload === 'function') {
		        instance.onUnload(evt);
		      }
		    }

		    return !isEventInstance;
		  });
		},

		loadSubSections: function(scope) {
		  if (!scope) {
		    return;
		  }

		  var sections = scope.querySelectorAll('[data-section-id]');

		  sections.forEach(el => {
		    this._onSectionLoad(null, el, el.dataset.sectionId);
		  });
		},

		_onSelect: function(evt) {
		  var instance = this._findInstance(evt.detail.sectionId);

		  if (
		    typeof instance !== 'undefined' &&
		    typeof instance.onSelect === 'function'
		  ) {
		    instance.onSelect(evt);
		  }
		},

		_onDeselect: function(evt) {
		  var instance = this._findInstance(evt.detail.sectionId);

		  if (
		    typeof instance !== 'undefined' &&
		    typeof instance.onDeselect === 'function'
		  ) {
		    instance.onDeselect(evt);
		  }
		},

		_onBlockSelect: function(evt) {
		  var instance = this._findInstance(evt.detail.sectionId);

		  if (
		    typeof instance !== 'undefined' &&
		    typeof instance.onBlockSelect === 'function'
		  ) {
		    instance.onBlockSelect(evt);
		  }
		},

		_onBlockDeselect: function(evt) {
		  var instance = this._findInstance(evt.detail.sectionId);

		  if (
		    typeof instance !== 'undefined' &&
		    typeof instance.onBlockDeselect === 'function'
		  ) {
		    instance.onBlockDeselect(evt);
		  }
		},

		register: function(type, constructor, scope) {
		  this.constructors[type] = constructor;

		  var sections = document.querySelectorAll('[data-section-type="' + type + '"]');

		  if (scope) {
		    sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
		  }

		  sections.forEach(
		    function(container) {
		      this._createInstance(container, constructor, scope);
		    }.bind(this)
		  );
		},

		reinit: function(section) {
		  for (var i = 0; i < this.instances.length; i++) {
		    var instance = this.instances[i];
		    if (instance['type'] === section) {
		      if (typeof instance.forceReload === 'function') {
		        instance.forceReload();
		      }
		    }
		  }
		}
	});
  /*End commons for sections*/	
  /*
  https://www.npmjs.com/package/flickity-responsive option api
  */
  theme.AsSeenOn = (function() {
  	 
  
    function AsSeenOn(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.init();
    }
  
    AsSeenOn.prototype = Object.assign({}, AsSeenOn.prototype, {
      init: function() {
        var slider = this.container.querySelector('.brand-slider');

	    if (slider) {
	    
	    	var autoplay = slider.getAttribute('autoplay'),
		      	autoplaytimeout  = slider.getAttribute('autoplaytimeout'),
		      	desktopCol  = slider.getAttribute('desktop-col')*1,
		      	MobileCol  = slider.getAttribute('mobile-col')*1,
		      	arrow  = slider.getAttribute('enableArrow').toLowerCase(),
		      	bullet  = slider.getAttribute('enableBullet').toLowerCase();

		      	arrow = (arrow === "false") ? false : true;
		      	bullet = (bullet === "false") ? false : true;
          		MobileCol = MobileCol - 1

          		 const swiper = new Swiper(slider, {
				  breakpoints: {
				  	320: {
					  //initialSlide: 1,
					  slidesPerGroup: 3,
					  slidesPerView: 'auto',
					  spaceBetween: 0,
					   centeredSlides: false,
				       pagination: {
					    el: '.swiper-pagination',
					    clickable: true,
					  }
				    },
				    900: {
				      centeredSlides: false,
				      slidesPerView: desktopCol,
				      spaceBetween: 0,
				      pagination: {
					    el: '.swiper-pagination',
					    clickable: true,
					  }
				    }
				  }


				  
				});

    //       		const swiper = new Swiper(slider, {
				//   	grabCursor: true,
				//   	slidesPerView:1,
				// 	loop: true,
				// 	autoHeight: true,
				//       pagination: {
				// 	    el: '.swiper-pagination',
				// 	    clickable: true,
				// 	  }
				// });
				

        }


      } 

    });
  
    return AsSeenOn;
  })();
 
 theme.ProductListNew = (function() {
  	 
  
    function ProductListNew(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.init();
    }
  
    ProductListNew.prototype = Object.assign({}, ProductListNew.prototype, {
      init: function() {
        var slider = this.container.querySelector('scroll-carousel-product-list');

	    if (slider) {
	    
	    	var autoplay = slider.getAttribute('autoplay'),
		      	autoplaytimeout  = slider.getAttribute('autoplaytimeout'),
		      	desktopCol  = slider.getAttribute('desktop-col')*1,
		      	MobileCol  = slider.getAttribute('mobile-col')*1,
		      	arrow  = slider.getAttribute('enableArrow').toLowerCase(),
		      	bullet  = slider.getAttribute('enableBullet').toLowerCase();

		      	arrow = (arrow === "false") ? false : true;
		      	bullet = (bullet === "false") ? false : true;
          		MobileCol = MobileCol - 1

	          	const swiper = new Swiper(slider, {
				  breakpoints: {
				  	 320: {
					  centeredSlides: false,
					  slidesPerView: 'auto',
					  spaceBetween: 0,
				      navigation: {             
				            nextEl: ".swiper-button-next",
				            prevEl: ".swiper-button-prev",
				      }
				    },
				    700: {
				      slidesPerView: 3,
				      spaceBetween: 0,
				      centeredSlides: false,
				      navigation: {             
				            nextEl: ".swiper-button-next",
				            prevEl: ".swiper-button-prev",
				      }
				    },
				    1000: {
				      centeredSlides: false,
				      slidesPerView: desktopCol,
				      spaceBetween: 0,
				      navigation: {             
				            nextEl: ".swiper-button-next",
				            prevEl: ".swiper-button-prev",
				      }
				    }
				  }
				  
				});
       
          		

        }

      } 

    });
  
    return ProductListNew;
  })();


  theme.CollectionListNew = (function() {
  	 
  
    function CollectionListNew(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.init();
    }
  
    CollectionListNew.prototype = Object.assign({}, CollectionListNew.prototype, {
      init: function() {
        var slider = this.container.querySelector('scroll-carousel-new');

	    if (slider) {
	    
	    	var autoplay = slider.getAttribute('autoplay'),
		      	autoplaytimeout  = slider.getAttribute('autoplaytimeout'),
		      	desktopCol  = slider.getAttribute('desktop-col')*1,
		      	MobileCol  = slider.getAttribute('mobile-col')*1,
		      	arrow  = slider.getAttribute('enableArrow').toLowerCase(),
		      	bullet  = slider.getAttribute('enableBullet').toLowerCase();

		      	arrow = (arrow === "false") ? false : true;
		      	bullet = (bullet === "false") ? false : true;
          		MobileCol = MobileCol - 1

	          	const swiper = new Swiper(slider, {
				  breakpoints: {
				  	 320: {
					  centeredSlides: true,
					  slidesPerView: 'auto',
					  spaceBetween: 0,
					   centeredSlides: true,
				      navigation: {             
				            nextEl: ".swiper-button-next",
				            prevEl: ".swiper-button-prev",
				      }
				    },
				    699: {
				      slidesPerView: 2,
				      spaceBetween: 0,
				      centeredSlides: false,
				      navigation: {             
				            nextEl: ".swiper-button-next",
				            prevEl: ".swiper-button-prev",
				      }
				    },
				    1149: {
				    	centeredSlides: false,
				      slidesPerView: desktopCol,
				      spaceBetween: 0,
				      navigation: {             
				            nextEl: ".swiper-button-next",
				            prevEl: ".swiper-button-prev",
				      }
				    }
				  }
				  
				});
       
          		

        }

      } 

    });
  
    return CollectionListNew;
  })();


  theme.InstagramNew = (function() {
  	 
  
    function InstagramNew(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.init();

      this.settings = {
	      mediaQueryDesktop: 'screen and (min-width: 1000px)',
	      mediaQueryMobile: 'screen and (max-width: 999px)',
	      bpSmall: false,
	  };
	  	this.selectors = { slider: 'instagram-posts' };

	    

	  this.initMobileBreakpoint = this._initMobileBreakpoint.bind(this);
	  this.initDesktopBreakpoint = this._initDesktopBreakpoint.bind(this);

	  this.mqlMobile = window.matchMedia(this.settings.mediaQueryMobile);
	  this.mqlMobile.addListener(this.initMobileBreakpoint);

	  this.mqlDesktop = window.matchMedia(this.settings.mediaQueryDesktop);
	  this.mqlDesktop.addListener(this.initDesktopBreakpoint);

	  this.initMobileBreakpoint();
	  this.initDesktopBreakpoint();
    }
  
	InstagramNew.prototype = Object.assign({}, InstagramNew.prototype, {
     	init: function (){
     		var slider = this.container.querySelector('.instagram-moible');
   		 

			if (slider) {
				    
		    	var autoplay = slider.getAttribute('autoplay'),
			      	autoplaytimeout  = slider.getAttribute('autoplaytimeout'),
			      	desktopCol  = slider.getAttribute('desktop-col')*1,
			      	MobileCol  = slider.getAttribute('mobile-col')*1,
			      	arrow  = slider.getAttribute('enableArrow').toLowerCase(),
			      	bullet  = slider.getAttribute('enableBullet').toLowerCase();

			      	arrow = (arrow === "false") ? false : true;
			      	bullet = (bullet === "false") ? false : true




				const swiper = new Swiper(slider, {
				  // initialSlide: 1,
				  grabCursor: true,
				  // centeredSlides: flase,
				  slidesPerView: 'auto',
				   centeredSlides: false,
				  slidesPerView: 1,
					loop: true,
					  
				      // navigation: {             
				      //       nextEl: ".swiper-button-next",
				      //       prevEl: ".swiper-button-prev",
				      // }
				});
		 

			}
     	},
      	_initMobileBreakpoint: function() { 
   			if (this.mqlMobile.matches) {
	  
			}
	 
  		},
	    _initDesktopBreakpoint: function() {
	     	if (this.mqlDesktop.matches) {
	  
			}
		}
		});
  
    return InstagramNew;
  })();

  theme.TestimonialsNew = (function() {
  	 
  
    function TestimonialsNew(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.init();
    }
  
    TestimonialsNew.prototype = Object.assign({}, TestimonialsNew.prototype, {
      init: function() {
        var slider = this.container.querySelector('.testimonials-slider');
   
	    if (slider) {
	    
	    	var autoplay = slider.getAttribute('autoplay'),
		      	autoplaytimeout  = slider.getAttribute('autoplaytimeout'),
		      	desktopCol  = slider.getAttribute('desktop-col')*1,
		      	MobileCol  = slider.getAttribute('mobile-col')*1,
		      	arrow  = slider.getAttribute('enableArrow').toLowerCase(),
		      	bullet  = slider.getAttribute('enableBullet').toLowerCase();

		      	arrow = (arrow === "false") ? false : true;
		      	bullet = (bullet === "false") ? false : true

	
				const swiper = new Swiper(slider, {
				  	grabCursor: true,
				  	slidesPerView:1,
					loop: true,
					autoHeight: true,
				      pagination: {
					    el: '.swiper-pagination',
					    clickable: true,
					  }
				});

        }


      } 

    });
  
    return TestimonialsNew;
  })();

  theme.TestimonialsLatest = (function() {
  	 
  
    function TestimonialsLatest(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.init();
    }
  
    TestimonialsLatest.prototype = Object.assign({}, TestimonialsLatest.prototype, {
      init: function() {
        var slider = this.container.querySelector('.testimonials-latest-slider');
   		
	    if (slider) {
	    
	    	var autoplay = slider.getAttribute('autoplay'),
		      	autoplaytimeout  = slider.getAttribute('autoplaytimeout'),
		      	desktopCol  = slider.getAttribute('desktop-col')*1,
		      	MobileCol  = slider.getAttribute('mobile-col')*1,
		      	arrow  = slider.getAttribute('enableArrow').toLowerCase(),
		      	bullet  = slider.getAttribute('enableBullet').toLowerCase();

		      	arrow = (arrow === "false") ? false : true;
		      	bullet = (bullet === "false") ? false : true

				const swiper = new Swiper(slider, {
				  	grabCursor: true,
				  	slidesPerView:1,
					loop: true,
					autoHeight: true,
				      pagination: {
					    el: '.swiper-pagination',
					    clickable: true,
					  }
				});

        }


      } 

    });
  
    return TestimonialsLatest;
  })();

  theme.CatOwners = (function() {
  	 
  
    function CatOwners(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.init();
    }
  
    CatOwners.prototype = Object.assign({}, CatOwners.prototype, {
      init: function() {
        var slider = this.container.querySelector('.cat-owners-slider');
   		
	    if (slider) {
	    
	    	var autoplay = slider.getAttribute('autoplay'),
		      	autoplaytimeout  = slider.getAttribute('autoplaytimeout'),
		      	desktopCol  = slider.getAttribute('desktop-col')*1,
		      	MobileCol  = slider.getAttribute('mobile-col')*1,
		      	arrow  = slider.getAttribute('enableArrow').toLowerCase(),
		      	bullet  = slider.getAttribute('enableBullet').toLowerCase();

		      	arrow = (arrow === "false") ? false : true;
		      	bullet = (bullet === "false") ? false : true

	
				const swiper = new Swiper(slider, {
				  breakpoints: {
				  	 320: {
					  slidesPerView: 'auto',
					  slidesPerView: 2.3,
					  spaceBetween: 0,
					  // centeredSlides: true,
				      navigation: {             
				            nextEl: ".cats-owner-list-wrapper .swiper-button-next",
				            prevEl: ".cats-owner-list-wrapper  .swiper-button-prev",
				      }
				    },
				    700: {
				      slidesPerView: desktopCol,
				      spaceBetween: 0,
				      centeredSlides: false,
				      navigation: {             
				            nextEl: ".cats-owner-list-wrapper .swiper-button-next",
				            prevEl: ".cats-owner-list-wrapper .swiper-button-prev",
				      }
				    },
				    1149: {
				    	centeredSlides: false,
				      slidesPerView: desktopCol,
				      spaceBetween: 0,
				      navigation: {             
				            nextEl: ".cats-owner-list-wrapper .swiper-button-next",
				            prevEl: ".cats-owner-list-wrapper .swiper-button-prev",
				      }
				    }
				  }
				  
				});

        }


      } 

    });
  
    return CatOwners;
  })();

  theme.RealReview = (function() {
  	 
  
    function RealReview(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.init();
    }
  
    RealReview.prototype = Object.assign({}, RealReview.prototype, {
      init: function() {
        var slider = this.container.querySelector('.real-brand-slider');

	    if (slider) {
	    
	    	var autoplay = slider.getAttribute('autoplay'),
		      	autoplaytimeout  = slider.getAttribute('autoplaytimeout'),
		      	desktopCol  = slider.getAttribute('desktop-col')*1,
		      	MobileCol  = slider.getAttribute('mobile-col')*1,
		      	arrow  = slider.getAttribute('enableArrow').toLowerCase(),
		      	bullet  = slider.getAttribute('enableBullet').toLowerCase();

		      	arrow = (arrow === "false") ? false : true;
		      	bullet = (bullet === "false") ? false : true;
          		MobileCol = MobileCol - 1

          		 const swiper = new Swiper(slider, {
				  breakpoints: {
				  	320: {
					  //initialSlide: 1,
					  slidesPerView: 'auto',
					  spaceBetween: 0,
					   centeredSlides: false,
					   spaceBetween: 0,
				    },
				    1000: {
				      centeredSlides: false,
				      slidesPerView: desktopCol,
				      spaceBetween: 0
				    }
				  }


				  
				});


        }


      } 

    });
  
    return RealReview;
  })();
  
  theme.ProductIconText = (function() {
  	 
  
    function ProductIconText(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.init();
    }
  
    ProductIconText.prototype = Object.assign({}, ProductIconText.prototype, {
      init: function() {
        var slider = this.container.querySelector('.product-icon-slider');

	    if (slider) {
	    
	    	var autoplay = slider.getAttribute('autoplay'),
		      	autoplaytimeout  = slider.getAttribute('autoplaytimeout'),
		      	desktopCol  = slider.getAttribute('desktop-col')*1,
		      	MobileCol  = slider.getAttribute('mobile-col')*1,
		      	arrow  = slider.getAttribute('enableArrow').toLowerCase(),
		      	bullet  = slider.getAttribute('enableBullet').toLowerCase();

		      	arrow = (arrow === "false") ? false : true;
		      	bullet = (bullet === "false") ? false : true;
          		MobileCol = MobileCol - 1

          		 const swiper = new Swiper(slider, {
				  breakpoints: {
				  	320: {
					  //initialSlide: 1,
					   slidesPerView: 'auto',
					  spaceBetween: 0,
					   centeredSlides: false,
				       pagination: {
					    el: '.swiper-pagination',
					    clickable: true,
					  }
				    },
				    600: {
					  //initialSlide: 1,
					   slidesPerView: 'auto',
					  spaceBetween: 0,
					   centeredSlides: false,
				       pagination: {
					    el: '.swiper-pagination',
					    clickable: true,
					  }
				    },
				    800: {
					  //initialSlide: 1,
					  slidesPerView: 'auto',
					  spaceBetween: 0,
					   centeredSlides: false,
				       pagination: {
					    el: '.swiper-pagination',
					    clickable: true,
					  }
				    },
				    999: {
				      centeredSlides: false,
				      slidesPerView: desktopCol,
				      slidesPerView: 'auto',
				      spaceBetween: 0,
				      pagination: {
					    el: '.swiper-pagination',
					    clickable: true,
					  }
				    }
				  }


				  
				});

    
				

        }


      } 

    });
  
    return ProductIconText;
  })();
  

 theme.heroSlideshow = (function () {
  function heroSlideshow(container) {
    this.container = container;
    this.sectionId = this.container.getAttribute("data-section-id");
    this.slider = null; // store Swiper instance here
    this.init();
  }

  heroSlideshow.prototype = Object.assign({}, heroSlideshow.prototype, {
    init: function () {
      var slider = this.container.querySelector(".hero-wrap");

      if (slider) {
        var autoplay = slider.getAttribute("autoplay"),
          autoplaytimeout = slider.getAttribute("autoplaytimeout");

        // ✅ Save swiper instance into this.slider
        this.slider = new Swiper(slider, {
          grabCursor: true,
          slidesPerView: 1,
          loop: true,
          autoHeight: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          autoplay:
            autoplay === "true"
              ? {
                  delay: (autoplaytimeout || 3000) * 1, // convert sec → ms
                  disableOnInteraction: false,
                }
              : false,
        });

        this.bindEditorEvents();
      }
    },

    bindEditorEvents: function () {
      var self = this;

      // When block is selected in Shopify Customize
      document.addEventListener("shopify:block:select", function (evt) {
        if (!self.slider) return;

        const blockId = evt.target.getAttribute("data-block-id");
        const slideEl = self.container.querySelector(
          '.swiper-slide[data-block-id="' + blockId + '"]'
        );

        if (slideEl) {
          const index = [...slideEl.parentNode.children].indexOf(slideEl);
          self.slider.slideToLoop(index); // loop-safe navigation
        }
      });

      // Optional: When block deselected
      document.addEventListener("shopify:block:deselect", function () {
        if (self.slider && self.slider.autoplay) {
          self.slider.autoplay.start();
        }
      });
    },
  });

  return heroSlideshow;
})();


  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  DOMready(function(){
    theme.sections = new theme.Sections();
    theme.sections.register('as-seen', theme.AsSeenOn);

    // Homepage carousels start at DOM ready, not on the delayed StartAsyncLoading event:
    // waiting for the first scroll/tap made every carousel re-lay out mid-scroll (2026-10-06).
    // Test the template, not the path, so market roots like /en-au get them too.
    if ( document.body.classList.contains('template-index') ){
    theme.sections.register('hero-slideshow', theme.heroSlideshow);
    theme.sections.register('ProductListNew', theme.ProductListNew);
    theme.sections.register('CollectionListNew', theme.CollectionListNew);
    theme.sections.register('instagram-new', theme.InstagramNew);
    //theme.sections.register('testimonials-new', theme.TestimonialsNew);
    theme.sections.register('testimonials-latest', theme.TestimonialsLatest);
    theme.sections.register('cat-owners', theme.CatOwners);
     
    document.dispatchEvent(new CustomEvent('page:loaded'));
    } else {
      
    theme.sections.register('ProductListNew', theme.ProductListNew);
    theme.sections.register('CollectionListNew', theme.CollectionListNew);
    theme.sections.register('instagram-new', theme.InstagramNew);
    theme.sections.register('testimonials-new', theme.TestimonialsNew);
    theme.sections.register('real-review', theme.RealReview);
    //theme.sections.register('ProductIconText', theme.ProductIconText);
    //theme.sections.register('testimonials-latest', theme.TestimonialsLatest);

     
    document.dispatchEvent(new CustomEvent('page:loaded'));

    }
    

    
  });


})(); //end

// Add an event listener for scroll
// off this code 8-3-24 by koderweb

// document.addEventListener("DOMContentLoaded", (event) => {

//   window.addEventListener('scroll', header_scroll);

// 	var announcementBar = document.querySelector('.announcement-bar');
// 	var header = document.querySelector('header');
// 	var body = document.querySelector('body');

// 	// Calculate the height of the announcement bar
// 	var sticky = announcementBar.clientHeight;

// 	function header_scroll() {
// 	  if (window.pageYOffset > sticky) {
// 	    header.classList.add("sticky");
// 	    body.classList.add("sticky-active");
// 	  } else {
// 	    header.classList.remove("sticky");
// 	    body.classList.remove("sticky-active");
// 	  }
// 	}

// });
document.addEventListener("DOMContentLoaded", () => {
  const announcementBar = document.querySelector('.announcement-bar');
  const header = document.querySelector('header');
  const body = document.querySelector('body');

  // Only proceed if both header and body exist
  if (!header || !body) return;

  // Calculate the height of the announcement bar if it exists, otherwise 0
  const sticky = announcementBar ? announcementBar.clientHeight : 0;

  function header_scroll() {
    if (window.pageYOffset > sticky) {
      header.classList.add("sticky");
      body.classList.add("sticky-active");
    } else {
      header.classList.remove("sticky");
      body.classList.remove("sticky-active");
    }
  }

  window.addEventListener('scroll', header_scroll);
});

jQuery(document).ready(function($) {
	 
 

	$('#product-extra-information details').click(function(event) {
		/* Act on the event */
		
          	$(this).siblings('').removeAttr('open')
          	$(this).siblings('').removeClass('active')

            $(this).attr('open');
            $(this).addClass('active');

 
	});

	$('.question-answer .question').click(function(event) {
	    const isActive = $(this).hasClass('active');

	    // Remove active class and slide up all answers
	    $('.question-answer .question').removeClass('active');
	    $('.question-answer .answer').slideUp(400);

	    // If the clicked question was not active, add active class and slide down the answer
	    if (!isActive) {
	        $(this).toggleClass('active');
	        $(this).next('.answer').slideDown(400);
	    }
	});

	  // Handle click event on accordion titles
	  $('.accordion-wrap li a').click(function(e) {
	    e.preventDefault(); // Prevent the default link behavior

	    // Get the data-content value of the clicked title
	    var contentId = $(this).attr('data-content');

	    // Remove 'active' class from all accordion titles and content divs
	    $('.accordion-wrap li').removeClass('active');
	    $('.accordion-content').removeClass('active');

	    // Add 'active' class to the clicked title
	    $(this).parent('li').addClass('active');

	    // Add 'active' class to the corresponding content div
	    $('#' + contentId).addClass('active');
	  });


	  $(document).ready(function () {
		  updateVideoButtons();
		  $(window).resize(updateVideoButtons);
		});

		function updateVideoButtons() {
		  if (window.innerWidth <= 999) {
		  	//$('.product-image-video .desktop_video video').css('display', 'none');
		    $('.product-image-video .image-wrapper').css('display', 'block');
	    	$('.product-image-video .mobile_video').css('display', 'none');
		  } else {
		  	//$('.product-image-video .mobile_video video').css('display', 'none');
		  	$('.product-image-video .image-wrapper').css('display', 'block');
	    	$('.product-image-video .desktop_video').css('display', 'none');

		    
		  }
		}


	  $('.video_link_absolute.mobile').click(function(e) {
	    e.preventDefault();  
	    //working on desktop
	    $('.product-image-video .image-wrapper').css('display', 'none');
	    $('.product-image-video .desktop_video').css('display', 'block');

	    $(".product-image-video .desktop_video video").trigger('play');
	  });

	  $('.video_link_absolute.desktop').click(function(e) {
	    e.preventDefault();  
	    //working on mobile
	    $('.product-image-video .image-wrapper').css('display', 'none');
	    $('.product-image-video .mobile_video').css('display', 'block');

	    $(".product-image-video .mobile_video video").trigger('play');
	  });

	  // $(".product-image-video .mobile_video video, .product-image-video .desktop_video video").each(function () {
		//   this.pause();
		//   this.currentTime = 0;
		// });

	  

		


	  $('button[aria-controls="sidebar-menu"]').click(function(event) {
	  	event.preventDefault();
	  	$('body').addClass('menu-overflow');

	  	$('#sidebar-menu').addClass('active');
	  	$('.mobile-sidebar-overlay').addClass('active');
	  });
	   var clickCount = 0;
	  $('.nav-close').click(function(event) {
	  	event.preventDefault();

	  	$('body').removeClass('menu-overflow');
	  	$('body').removeClass('search-animation');

	  	$('#sidebar-menu').removeClass('active');
	  	$('.mobile-sidebar-overlay').removeClass('active');
	  	$('.image-second-level-menu').removeClass('active');
	  	clickCount = 0;


	  });
	  $('.mobile-sidebar-overlay').click(function(event) {
	  	event.preventDefault();
	  	$('body').removeClass('menu-overflow');
	  	$('body').removeClass('search-animation');

	  	$('#sidebar-menu').removeClass('active');
	  	$('.mobile-sidebar-overlay').removeClass('active');
	  	$('.image-second-level-menu').removeClass('active');
	  	

		$('.header-search').removeClass('menu_active')

	  });
	  // 2026-10-15: tapping a link in the open phone menu left the page in the back/forward cache with the menu
	  // open and the page scroll-locked (body.menu-overflow), and on Back iOS Safari restored it that way and the
	  // page skipped upward. Close the menu as the page is left, the same way the X button does, with the slide
	  // switched off so it doesn't play on return; the page then comes back unlocked where it was left.
	  window.addEventListener('pagehide', function () {
	  	var sidebar = document.getElementById('sidebar-menu');
	  	if (!sidebar || !sidebar.classList.contains('active')) return;
	  	sidebar.style.transition = 'none';
	  	$('body').removeClass('menu-overflow');
	  	$('body').removeClass('search-animation');
	  	$('#sidebar-menu').removeClass('active');
	  	$('.mobile-sidebar-overlay').removeClass('active');
	  	$('.image-second-level-menu').removeClass('active');
	  	clickCount = 0;
	  	void sidebar.offsetWidth;
	  });
	  window.addEventListener('pageshow', function () {
	  	var sidebar = document.getElementById('sidebar-menu');
	  	if (sidebar) sidebar.style.transition = '';
	  });
	  // 2026-10-15: registered once here. It used to be added inside the overlay and search-icon click handlers,
	  // so another copy piled up on every click (same effect: a force-closed dialog resets the search toggle count).
	  document.addEventListener('dialog:force-close', (event) => {
			clickCount = 0;
	  });
	  
	  $('.image-top-level-item a.has_child').click(function(event) {
	  	event.preventDefault();

	  	$(this).next().toggleClass('active');

	  	var $dropdownArrow = $(this).find('.dropdown_avialble');

	    if ($dropdownArrow.hasClass('down')) {
	        $dropdownArrow.removeClass('down').addClass('up');
	    } else {
	        $dropdownArrow.removeClass('up').addClass('down');
	    }

	  });
	 
	  $('.mobile-header-right svg.header__nav-icon').click(function(event) {
	  	event.preventDefault();
	  	 
	  	clickCount++;  

	    
	  	$('body').toggleClass('search-animation');
		$('.header-search').toggleClass('menu_active');

		// 2026-10-15: match the end of the href. On market URLs the link is /en-au/search etc., so the old
		// exact [href="/search"] found nothing and .click() threw on null.
		var searchLinkEl = document.querySelector('.header__secondary-nav [href$="/search"]');
		if (searchLinkEl) searchLinkEl.click();

    	var searchLink = $('.header__secondary-nav [href$="/search"]');


	    if (clickCount % 2 !== 0) {
	    	$('header-search').attr('open');
	    	$('body').addClass('search-animation');
	    	$('.header-search').addClass('menu_active');

	        searchLink.attr('aria-expanded', 'true');
	    } 
	    else {
	    	$('header-search').removeAttr('open');
	        searchLink.attr('aria-expanded', 'false');
	        $('body').removeClass('search-animation');
	        $('.header-search').removeClass('menu_active');

	        document.querySelector('dialog-close-button').click();


	    }

   
 



	  });


});
document.addEventListener("DOMContentLoaded", (event) => {
	document.addEventListener('dialog:force-close', (event) => {
		 
		$('body').removeClass('search-animation');
		//$('.header-search').removeClass('menu_active');
	});
});
const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', appHeight)
appHeight();



// 2026-10-15: the phone menu's category pictures (lazysizes) only started downloading when a submenu
// opened, so its tiles showed blank for a few frames. Fetch them once the page is idle (phones only: the
// menu button is hidden on desktop), or as soon as the menu button is touched.
(function () {
  var done = false;
  function warm() {
    if (done) return;
    done = true;
    document.querySelectorAll('#sidebar-menu img.lazyload[data-src]').forEach(function (img) {
      if (window.lazySizes && lazySizes.loader) lazySizes.loader.unveil(img);
      else { img.src = img.getAttribute('data-src'); img.classList.remove('lazyload'); }
    });
  }
  var btn = document.querySelector('button[aria-controls="sidebar-menu"]');
  if (!btn) return;
  btn.addEventListener('pointerdown', warm, { once: true });
  function idle() {
    if (!btn.offsetParent) return;
    if (window.requestIdleCallback) requestIdleCallback(warm, { timeout: 3000 });
    else setTimeout(warm, 1500);
  }
  if (document.readyState === 'complete') idle();
  else window.addEventListener('load', idle);
})();


// 2026-10-15: tapping a product card, or a collection/product link in the phone menu, showed the next page
// with grey boxes for a moment while its main photos downloaded. The photos it opens on are named on the
// link (data-wt-next / data-wt-next-cards, see product-card.liquid and header-sidebar-new.liquid); start
// them when the finger lifts on a tap, a few hundred ms before the new page renders. Widths mirror what that
// page's srcset picks on a phone (gallery: 100vw - 40px; collection cards: two per row), so the new page
// finds them already downloaded. Phones only (under 700px wide).
(function () {
  var W = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800, 2000, 2200, 2400, 2600, 2800, 3000, 3200];
  var seen = {};
  function pick(slot, max, list) {
    var need = slot * (window.devicePixelRatio || 1), best = 0;
    for (var i = 0; i < list.length; i++) {
      if (max && list[i] > max) break;
      best = list[i];
      if (list[i] >= need) break;
    }
    return best;
  }
  function get(url200, w) {
    if (!url200 || !w) return;
    var url = url200.replace(/([?&]width=)200\b/, '$1' + w);
    if (seen[url]) return;
    seen[url] = 1;
    var img = new Image();
    img.src = url;
  }
  /* a tap, not a scroll: a touch that turns into a scroll ends in pointercancel, never pointerup */
  document.addEventListener('pointerup', function (e) {
    if (window.innerWidth >= 700 || e.pointerType === 'mouse') return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var host = a.closest('[data-wt-next], [data-wt-next-cards]');
    if (!host) return;
    var next = host.getAttribute('data-wt-next');
    if (next && /\/products\//.test(a.getAttribute('href'))) {
      get(next, pick(window.innerWidth - 40, +host.getAttribute('data-wt-next-max') || 0, W));
    }
    var cards = (host.getAttribute('data-wt-next-cards') || '').split(',');
    for (var i = 0; i < cards.length; i++) {
      var p = cards[i].trim().split(' ');
      if (p[0]) get(p[0], pick(window.innerWidth / 2, +p[1] || 0, W.slice(0, 8)));
    }
  }, { passive: true, capture: true });
})();

// 2026-10-15: desktop. Opening a collection from the menu showed its product cards empty for ~0.3s while the
// photos downloaded. When the pointer rests on a collection link, fetch that collection's first four card
// photos at the size the collection grid picks (its sizes attribute assumes three per row: (100vw - 96px) / 3
// - 16px, main-collection's default; widths 200-1000 as in product-card.liquid), so the page opens with them already downloaded.
(function () {
  if (!window.matchMedia('(hover: hover) and (min-width: 1000px)').matches) return;
  var W = [200, 300, 400, 500, 600, 700, 800, 1000], done = {}, timer = 0;
  function width(max) {
    var need = ((window.innerWidth - 96) / 3 - 16) * (window.devicePixelRatio || 1), best = 0;
    for (var i = 0; i < W.length; i++) {
      if (max && W[i] > max) break;
      best = W[i];
      if (W[i] >= need) break;
    }
    return best;
  }
  function warm(handle) {
    if (done[handle]) return;
    done[handle] = 1;
    fetch('/collections/' + handle + '/products.json?limit=4').then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      ((d && d.products) || []).slice(0, 4).forEach(function (p) {
        var im = p.images && p.images[0];
        if (!im || !im.src) return;
        var base = im.src.replace(/^https?:\/\/cdn\.shopify\.com\/s\/files\/\d+\/\d+\/\d+\/\d+\//, '//' + location.host + '/cdn/shop/');
        if (base === im.src) return;
        var w = width(im.width);
        if (!w) return;
        var img = new Image();
        img.src = base + (base.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
      });
    }).catch(function () {});
  }
  document.addEventListener('mouseover', function (e) {
    clearTimeout(timer);
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var m = (a.getAttribute('href') || '').match(/^(?:https?:\/\/[^/]+)?(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/([^/?#]+)\/?(?:[?#]|$)/);
    if (m) timer = setTimeout(function () { warm(m[1]); }, 80);
  }, { passive: true });
})();
